import { trigger, animate, transition, style, animation, useAnimation } from '@angular/animations';

const fadeAnimation = animation([style({ opacity: 1 }), animate('{{ duration }}ms', style({ opacity: 0 }))]);

const enterTransition = transition(
  ':enter',
  useAnimation(fadeAnimation, {
    params: { duration: '1000' },
  }),
);

export const fadeInLayerImage = trigger('fadeInLayerImage', [enterTransition]);
